// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/icons/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
}

.main :where(header, section, footer) {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
}
.main :where(header, section, footer) > .container {
  padding: 0 3%;
}

@media (max-width: 1350px) {
  .main :where(header, section, footer) > .container {
    padding: 0 3%;
  }
}

.container {
  max-width: 1280px;
  width: 100%;
}

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header .container {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 30px 30px;
  background: #0c6b60;
}

.header .container .header__desktop {
  width: 100%;
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header__desktop__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.header__desktop__nav {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header__desktop__nav > a {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
}

.header__desktop__nav > a::after {
  content: "";
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  width: 0%;
  height: 1px;
  background: #fff;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.header__desktop__nav > a.active::after {
  width: 100%;
}

.header__desktop__content > a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--White, #fff);
  font-size: 15px;
  font-weight: 400;
}

.header__desktop__content > button {
  display: none;
  font-size: 28px;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
}

.header .container .header__mobile {
  width: 100%;
  padding: 0px 0;
  height: 0px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.header .container .header__mobile.active {
  height: 320px;
  padding: 16px 0;
}

.header__mobile__nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 35px;
  padding-bottom: 35px;
}

.header__mobile__nav > a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}

.header__mobile__nav > a.active {
  text-decoration-line: underline;
}

.header__mobile__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px 0;
  border-top: 1px solid #fff;
}

.header__mobile__content a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}

.section {
  flex: 1 1;
  padding: 5% 0;
}

.footer {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #797991;
}

.footer .container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer ol {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer ol a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  font-size: 16px;
}

@media (max-width: 1024px) {
  .header__desktop__content > a {
    display: none;
  }

  .header__desktop__content > button {
    display: flex;
  }

  .header__desktop__nav {
    display: none;
  }

}

@media (max-width: 520px) {
  .footer {
    height: auto;
    padding: 5% 3%;
  }

  .footer > .container {
    flex-direction: column;
    gap: 30px;
  }
  .footer ol a {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/layout.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mDAAqC;EACrC,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".main {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: url(/public/icons/bg.svg);\n  background-repeat: no-repeat;\n  background-position: top;\n  background-size: contain;\n}\n\n.main :where(header, section, footer) {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n}\n.main :where(header, section, footer) > .container {\n  padding: 0 3%;\n}\n\n@media (max-width: 1350px) {\n  .main :where(header, section, footer) > .container {\n    padding: 0 3%;\n  }\n}\n\n.container {\n  max-width: 1280px;\n  width: 100%;\n}\n\n.header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.header .container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0px 0px 30px 30px;\n  background: #0c6b60;\n}\n\n.header .container .header__desktop {\n  width: 100%;\n  padding: 16px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header__desktop__content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.header__desktop__nav {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.header__desktop__nav > a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.header__desktop__nav > a::after {\n  content: \"\";\n  position: absolute;\n  top: calc(100% + 3px);\n  left: 0;\n  width: 0%;\n  height: 1px;\n  background: #fff;\n  border-radius: 5px;\n  transition: all 0.2s ease;\n}\n\n.header__desktop__nav > a.active::after {\n  width: 100%;\n}\n\n.header__desktop__content > a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--White, #fff);\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.header__desktop__content > button {\n  display: none;\n  font-size: 28px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n}\n\n.header .container .header__mobile {\n  width: 100%;\n  padding: 0px 0;\n  height: 0px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.header .container .header__mobile.active {\n  height: 320px;\n  padding: 16px 0;\n}\n\n.header__mobile__nav {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n  padding-bottom: 35px;\n}\n\n.header__mobile__nav > a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.header__mobile__nav > a.active {\n  text-decoration-line: underline;\n}\n\n.header__mobile__content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 15px 0;\n  border-top: 1px solid #fff;\n}\n\n.header__mobile__content a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.section {\n  flex: 1;\n  padding: 5% 0;\n}\n\n.footer {\n  width: 100%;\n  height: 180px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #797991;\n}\n\n.footer .container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer ol {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer ol a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #ffffff;\n  font-size: 16px;\n}\n\n@media (max-width: 1024px) {\n  .header__desktop__content > a {\n    display: none;\n  }\n\n  .header__desktop__content > button {\n    display: flex;\n  }\n\n  .header__desktop__nav {\n    display: none;\n  }\n\n}\n\n@media (max-width: 520px) {\n  .footer {\n    height: auto;\n    padding: 5% 3%;\n  }\n\n  .footer > .container {\n    flex-direction: column;\n    gap: 30px;\n  }\n  .footer ol a {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
